import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { ConversationAllResponse } from '../types';
import axiosClient from '../utils/axiosClient';

export const useGetUserExecutionReport = (
  startDate: string,
  endDate: string
) => {
  return useQuery<any, AxiosError<any>, { report: string }>(
    ['reports', 'download-executions-report-by-user', startDate, endDate],
    async () => {
      const data = await axiosClient.get<ConversationAllResponse>(
        `/reports/download-executions-report-by-user`,
        {
          params: { startDate, endDate },
        }
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      enabled: false,
    }
  );
};
